export default __webpack_public_path__ + "static/media/15 Track 15.68b7be61.mp3";